
import { computed, defineComponent, nextTick, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  props: {
    height: {
      type: Number,
      required: false,
      default: null
    },
    tableData: {
      type: Array,
      required: true
    },
    columnStruct: {
      type: Array,
      required: true
    },
    listLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    hadOperate: {
      type: Boolean,
      required: false,
      default: true
    },
    operateText: {
      type: String,
      required: false,
      default: 'common.operate'
    },
    operateColumnWidth: {
      type: Number,
      required: false,
      default: 180
    },
    hadSelect: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultExpandAll: {
      type: Boolean,
      required: false,
      default: true
    },
    selectable: {
      type: Function,
      required: false,
      default: () => true
    },
    cellStyle: {
      type: Function,
      required: false,
      default: () => { return {} }
    },
    rowClassName: {
      type: Function,
      required: false,
      default: null
    },
    spanMethod: {
      type: Function,
      required: false,
      default: null
    }
  },
  setup(props) {
    const { t } = useI18n()
    const tableRef = ref()
    const selectedRows = ref<any[]>([])

    const getSelectionRows = () => {
      return selectedRows.value || []
    }
    const clearSelection = () => {
      if (tableRef.value) {
        tableRef.value.clearSelection()
        selectedRows.value = []
      }
    }
    const handleSelectionChange = (val: any) => {
      selectedRows.value = val
    }
    const normalColumns = computed(() =>
      props.columnStruct.filter((c: any) => !c.icon && !c.slot)
    )

    const slotColumns = computed(() =>
      props.columnStruct.filter((c: any) => !!c.slot)
    )

    const iconColumns = computed(() =>
      props.columnStruct.filter((c: any) => !!c.icon)
    )
    onMounted(() => {
      nextTick(() => {
        if (tableRef.value && tableRef.value.doLayout) {
          tableRef.value.doLayout()
        }
      })
    })
    return {
      t,
      tableRef,
      normalColumns,
      slotColumns,
      iconColumns,
      handleSelectionChange,
      getSelectionRows,
      clearSelection
    }
  }
})
